import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import IMG01 from "../../images/services/ec/Higher-Leads-and-Conversation-Rates.webp";
import IMG02 from "../../images/services/ec/Online-Shopping-Experience.webp";
import IMG03 from "../../images/services/ec/Global-Accessibility.webp";
import IMG04 from "../../images/services/ec/Scalable-and-Growth-Centric.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={10} xxl={10} className="my-auto">
                            <div className="example" data-text="Offer">
                                <h2>Ensure Optimal Growth with Tekrevol App Developers in Seattle
                                    What We Offer?</h2>
                            </div>
                            <p>TekRevol is more than a mediocre approach when it comes to the digital development of its client's business. In the global market, we have a strong reputation for our progressive methods of app development.</p>
                            <p>You are always welcome to discuss your ideas with our company, and our competent app developers in Seattle will provide you with the perfect solution according to your business requirements. We possess all the resources to deal with multiple scales of business ensuring a reliable development process.</p>
                            <p>Considering our expertise in custom app solutions, we will help you revolutionize your business process with the maximum opportunities to grow in the market.</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            {/*<div className="tekgrip_flex">*/}
                                {/*<div className="tekgrip_title">*/}
                                    {/*<h5>274B*/}
                                        {/*<span>Approx. market size</span></h5>*/}
                                {/*</div>*/}
                                {/*<div className="tekgrip_title">*/}
                                    {/*<h5>2.5M*/}
                                        {/*<span>Daily data production</span></h5>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Increase Brand Awareness</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Streamline Business Operations</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Overall Revenue Growth</div>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tabs">
                                <h2>Increase Brand Awareness</h2>
                                <p>In this digital age, a mobile app is nothing less than a branding itself. When you gain a designated space in the user’s device with your app, your app has already become the voice of your brand. With notifications and other interactions, you can engage the audience with your app which results in building a relationship with the brand.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image loc-img">
                                <LazyLoadImage
                                    src={IMG01}
                                    effect="blur" alt="Migration" className="img-fluid"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tabs">
                                <h2>Streamline Business Operations</h2>
                                <p>You can automate your operations by making the best use of the complex functionalities that our Seattle affordable app developers utilize in the application. It will help you save both time and effort while increasing the efficiency of the overall business process. As a result, you can take the maximum advantage of your app while efficiently facilitating your users</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image loc-img">
                                <LazyLoadImage
                                    src={IMG02}
                                    effect="blur" alt="Development" className="img-fluid"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tabs">
                                <h2>Overall Revenue Growth</h2>
                                <p>The scalability of your business will automatically increase by incorporating a mobile app. Having a mobile application provides you with multiple opportunities to interact with users while targeting the audience at a large scale. So, you can enhance your business growth by providing feasibility to your users making it a user preference.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image loc-img">
                                <LazyLoadImage
                                    src={IMG03}
                                    effect="blur" alt="Deployment" className="img-fluid"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Technologysec;